export const primaryPhones = [
  { display: '073387 21875', href: 'tel:+917338721875' },
  { display: '096262 97366', href: 'tel:+919626297366' },
] as const;

export const alternatePhones = [
  { display: '9360299056', href: 'tel:+919360299056' },
  { display: '9444651630', href: 'tel:+919444651630' },
] as const;

export const whatsappNumber = '917338721875';

export const primaryEmail = 'yspscientific@gmail.com';
export const secondaryEmail = 'sales.yspscientific@gmail.com';
